import qs from 'qs';

import ApiService from 'services/ApiService/ApiService';
import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import { translate } from 'services/i18nService';
import messagingService from 'services/MessagingService/MessagingService';
import {
  BUY_GROUP_SHOW_TICKET_RESPONSE,
  CONNECT_TO_GROUP_SHOW_CHAT,
  DISABLE_GAME,
  REMAINING_TIME_UNTIL_GROUP_SHOW,
  REQUEST_PLAY_TOKEN,
  TICKET_SELLING_FAILED,
  TICKET_SELLING_STARTED,
  UPDATE_GS_SUCCESS,
} from 'services/MessagingService/EventNames';
import ModalService from 'services/ModalService';
import NotificationService from 'services/NotificationService';
import { GROUPSHOW_ACTIONS } from 'enum/helpers';
import { SECOND_AS_MILLISECONDS } from 'enum/timeFormat';
import { focusChatInputField } from 'utils/helpers';
import parseCatch from 'utils/parseCatch';


const WEBCHAT_HOST = ConfigurationService.get(ConfigurationKeys.WEB_CHAT_HOST);
const GROUPSHOW_ACTION_URL = `${WEBCHAT_HOST}groupShowAction`;
const GROUPSHOW_START_URL = `${WEBCHAT_HOST}groupShowSettingsServlet`;
const GROUPSHOW_PLAY_TOKEN_URL = `${WEBCHAT_HOST}requestGroupShowToken`;
const WEBSERVER_TIMESTAMP_URL = `${WEBCHAT_HOST}webServerTimestamp`;

class GroupShowService {
  constructor() {
    this.messagingService = messagingService();
  }

  destructor() {
    this.messagingService = null;
  }

  getExactRemainingTime = (end) => {
    let remainingMilliseconds = undefined;
    let timerInSeconds = undefined;
    let newTimestamp = undefined;

    const encodedUrl = encodeURI(WEBSERVER_TIMESTAMP_URL);
    ApiService.get(encodedUrl)
      .then((res) => {
        newTimestamp = res.data;
        // Get how much time has passed since selling tickets started and selling duration
        remainingMilliseconds = end - newTimestamp;
        timerInSeconds = parseInt(Math.round(remainingMilliseconds / SECOND_AS_MILLISECONDS), 10);
        this.messagingService.emit(REMAINING_TIME_UNTIL_GROUP_SHOW, timerInSeconds);
      })
      .catch((error) => parseCatch(error));
  };

  buyGroupShowTicket = (data, callBackFnc) => {
    ApiService.post(GROUPSHOW_ACTION_URL, {
      data: qs.stringify(data),
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
    })
      .then((res) => {
        this.messagingService.emit(BUY_GROUP_SHOW_TICKET_RESPONSE, res.data);
        callBackFnc?.();
      })
      .catch((error) => parseCatch(error));
  };

  getPlayTokenForGroupShow = (data) => {
    ApiService.post(GROUPSHOW_PLAY_TOKEN_URL, {
      data: qs.stringify(data),
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
    })
      .then((res) => {
        const chatConnectData = {
          roomName: data.roomname,
          token: res.data.token,
          user: data.username,
        };
        this.messagingService.emit(REQUEST_PLAY_TOKEN, res.data);
        this.messagingService.emit(CONNECT_TO_GROUP_SHOW_CHAT, chatConnectData);
      })
      .catch((error) => parseCatch(error));
  };

  startSellingTickets = (data) => {
    ApiService.post(GROUPSHOW_START_URL, {
      data: qs.stringify(data),
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
    })
      .then(() => {
        ModalService.hideModal();
        this.messagingService.emit(TICKET_SELLING_STARTED);
      })
      .catch((error) => {
        this.messagingService.emit(TICKET_SELLING_FAILED);
        NotificationService.create({
          type: NotificationService.type.TOAST,
          text: translate('account.errorGeneric'),
          subtype: NotificationService.subtype.ERROR,
        });
        parseCatch(error);
      });
  };

  handleGroupShow = (data) => {
    ApiService.post(GROUPSHOW_ACTION_URL, {
      data: qs.stringify(data),
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
    })
      .then(() => {
        this.messagingService.emit(UPDATE_GS_SUCCESS);
        ModalService.hideModal();
        if (data?.action === GROUPSHOW_ACTIONS.START_GS) {
          this.messagingService.emit(DISABLE_GAME);
          focusChatInputField();
        }
      })
      .catch((error) => parseCatch(error));
  };
}

export default new GroupShowService();
